
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { DataGrid, GridRowData, GridRowId, GridRowsProp } from '@material-ui/data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/context';
import { MyTableProps } from '../../Interfaces/Interfaces';
import AdminDelete from './AdminDelete/AdminDelete';
import TableToolsBar from './TableToolsBar/TableToolsBar'

const styles = (theme: Theme) => createStyles({
	root: {
		"& .MuiDataGrid-row:hover": {
			backgroundColor: theme.palette.primary.main,
			color:theme.palette.secondary.main
		},
		"& .MuiDataGrid-row:hover .editIcon": {
			color: theme.palette.secondary.main
		},
		"& .Mui-selected": {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.secondary.main
		},
		"& .Mui-selected .editIcon": {
			color: theme.palette.secondary.main
		},
		"& .MuiDataGrid-row.Mui-selected": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.secondary.main
		},

		"& .MuiDataGrid-row.Mui-selected:hover": {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.secondary.main
		},
		"& .MuiDataGrid-cell:focus": {
			outline: "none",
		},
		"& .MuiDataGrid-window": {
			overflowX: 'initial',
			//[theme.breakpoints.up('1800')]: {
			//	overflowX: 'hidden'
			//}
		},
		"& .MuiDataGrid-colCellTitle": {
			fontWeight: 700
		},
		'& .blue': {
			color: 'blue'
		},
		'& .red': {
			color: 'red'
		},
		'& .MuiDataGrid-row.Mui-selected .blue': {
			color:'#04d9ff'
		},
		'& .MuiDataGrid-row:hover .blue': {
			color:'#04d9ff'
		},
		'& .MuiDataGrid-row:hover .MuiDataGrid-cellCheckbox .MuiIconButton-label': {
			color: theme.palette.secondary.main
		},
		'& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cellCheckbox .MuiIconButton-label': {
			color:theme.palette.secondary.main
		},
		boxShadow: " 0 15px 10px #777",
	},
	button: {
		color: 'orange'
	},
	wrapper: {
		paddingTop: '2.5rem',
		height: 600,
		width: '100%',
	},
	searchBox: {
		marginTop:'2.5rem'
	}	
})


const Table = (props: MyTableProps) => {
	const classes = makeStyles(styles)();
	const { sharedData: { isLogged, modalPayload: rowsChecked } } = useContext(AppContext);
	const {
		action:
		clickHandler,
		columns,
		rows: rowData,
		deletableContent,
		editTable,
		createContent,
		editContent,
		dataObject,
		stopPropagation,
		overide,
	} = props;

	const [rows, setRows] = useState<GridRowData | null>(rowData);
	const [checkable, setCheckable] = useState<boolean>(false)

	useEffect(() => {
		setRows(rowData)
		return ()=>setCheckable(false)
	}, [rowData])

	const [selectionModel, setSelectionModel] = useState<Array<GridRowId>>(rowsChecked);

	return (

		<Grid container justify="flex-end">
			<Grid item xs={12}
			className={classes.wrapper}
			>
				<DataGrid
					className={classes.root}
					columnBuffer={9}
					density="comfortable"
					columns={columns}
					checkboxSelection={isLogged && checkable? true : overide? true : false}
					rows={rows !== null ? rows as GridRowsProp : []}
					//autoPageSize
					loading={rows === null}
					components={{
						Pagination: AdminDelete,
						Toolbar: TableToolsBar,
					}}
					onSelectionModelChange={(newSelection) => {
						setSelectionModel(newSelection.selectionModel)
					}}
					selectionModel={selectionModel}
					componentsProps={{
						toolbar: {
							overide,
							createContent,
							editTable,
							deletableContent,
							setCheckable,
							editContent

						},
						footer: {
							dataObject,
							overide,
							deletableContent,
							checkable
						}
					}}
					onCellClick={(evt) => {
						if (!overide && !stopPropagation && !checkable && evt.field !== ' ' && clickHandler/* && !editContent*/) {
							clickHandler(evt.row.id)
						}
					}}
				/>
			</Grid>
		</Grid>
	)
}
export default Table ;
